// extracted by mini-css-extract-plugin
export default {"donation_successful":"donation_successful_donation_successful__AG7Cs"};